<template>
  <div>
    <div class="button" @click="visible = true">
      <a-icon type="environment" style="font-size: 18px" />
      <div>选择标签</div>
    </div>

    <a-modal title="选择标签" :visible="visible" :footer="null" @cancel="visible = false" width="640px">
      <a-table bordered :data-source="list" :pagination="false" rowKey="id">
        <a-table-column title="名称" data-index="name"></a-table-column>
        <a-table-column title="操作" align="center" width="80px">
          <template slot-scope="text">
            <a href="#" @click.prevent="onClick(text)">{{ area.id === text.id ? '取消渲染' : '渲染' }}</a>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { fetchList } from "@/api/setting/map-label";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      visible: false,
      list: [],
    };
  },
  computed: {
    ...mapState("mapTools", ["area"]),
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      fetchList({
        pageNum: 1,
        pageSize: 99,
      }).then((res) => {
        if (res && Array.isArray(res.list)) {
          this.list = Object.freeze(res.list);
        }
      });
    },
    ...mapMutations("mapTools", ["setArea"]),
    onClick(item) {
      console.log("item", item);
      if (item.id === this.area.id) {
        this.setArea({});
      } else {
        if (item.locations) {
          this.setArea(item);
        }
      }
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
  position: relative;
}

.list {
  position: absolute;
  top: -8px;
  right: 100%;
  background-color: #fff;
  width: 10em;
  .label {
    cursor: pointer;
    padding: 4px 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .active {
    background-color: var(--theme-color);
    color: #fff;
  }
}
</style>